/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropdiscardbody2Inputs */

const en_dropdiscardbody2 = /** @type {(inputs: Dropdiscardbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have unsaved changes. Closing now will discard them.`)
};

const de_dropdiscardbody2 = /** @type {(inputs: Dropdiscardbody2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast ungespeicherte Änderungen. Wenn du jetzt schließt, gehen sie verloren.`)
};

/**
* | output |
* | --- |
* | "You have unsaved changes. Closing now will discard them." |
*
* @param {Dropdiscardbody2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropdiscardbody2 = /** @type {((inputs?: Dropdiscardbody2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropdiscardbody2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropdiscardbody2(inputs)
	return de_dropdiscardbody2(inputs)
});
export { dropdiscardbody2 as "dropDiscardBody" }